//import ApexCharts from 'apexcharts'
//import $ from 'jquery'

export default {
    methods: {
        loadScript(url) {
            const body = document.body;
            const script = document.createElement("script");
            script.innerHTML = "";
            script.src = url;
            script.async = false;
            script.defer = true;
            body.appendChild(script);
        },
        vizDashboardTwo(months, lastYearMonthlyData, thisYearMonthlyData, lastYear, currentYear, celebrantCount, pieChartData) {
            this.loadScript(`/lib/chart.js/Chart.bundle.min.js`)
            this.loadScript(`/lib/jquery.flot/jquery.flot.js`)
            this.loadScript(`/lib/jquery.flot/jquery.flot.stack.js`)
            this.loadScript(`/lib/jquery.flot/jquery.flot.resize.js`)
            this.loadScript(`/lib/peity/jquery.peity.min.js`)
            this.loadScript(`/assets/js/dashforge.sampledata.js`)


            this.loadScriptData(`let dLabel = ${JSON.stringify(months)};`);
            this.loadScriptData(`let dLastYearMonthlyData = ${JSON.stringify(lastYearMonthlyData)};`);
            this.loadScriptData(`let dThisYearMonthlyData = ${JSON.stringify(thisYearMonthlyData)};`);
            this.loadScriptData(`let lastYear = ${JSON.stringify(lastYear)};`);
            this.loadScriptData(`let currentYear = ${JSON.stringify(currentYear)};`);

            this.loadScriptData(`let months = ${JSON.stringify(months)};`);
            this.loadScriptData(`let celebrantCount = ${JSON.stringify(celebrantCount)};`);
            this.loadScriptData(`let pieChartData = ${JSON.stringify(pieChartData)};`);

            this.loadScript(`/assets/js/vizDashboardTwo.js`);
        },
        vizDashboardOne(labels, data1, data2) {
            this.loadScript(`/lib/chart.js/Chart.bundle.min.js`)
            this.loadScript(`/lib/jquery.flot/jquery.flot.js`)
            this.loadScript(`/lib/jquery.flot/jquery.flot.stack.js`)
            this.loadScript(`/lib/jquery.flot/jquery.flot.resize.js`)
            this.loadScript(`/assets/js/dashforge.sampledata.js`)

            this.loadScript(`/lib/jqvmap/jquery.vmap.min.js`)
            this.loadScript(`/lib/jqvmap/maps/jquery.vmap.usa.js`)

            this.loadScriptData(`let dLabel = ${JSON.stringify(labels)};`);
            this.loadScriptData(`let dData1 = ${JSON.stringify(data1)};`);
            this.loadScriptData(`let dData2 = ${JSON.stringify(data2)};`);
            this.loadScript(`/assets/js/vizDashboardOne.js`);
        },
    }
};
